import { render, staticRenderFns } from "./Backgrounds.vue?vue&type=template&id=479a47c6&"
import script from "./Backgrounds.vue?vue&type=script&lang=js&"
export * from "./Backgrounds.vue?vue&type=script&lang=js&"
import style0 from "./Backgrounds.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports